<template>
  <div id="register">
    <section class="section">
      <div class="container mt-5">
        <div class="row">
          <div class="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="login-brand">
              <a href="/">
                <img
                  :src="require('@/assets/img/icon-jembrana-20.png')"
                  alt="logo"
                  width="100"
                  class="shadow-light"
                  @click="$router.push({path: '/'})"
                  style="cursor:pointer"
                >
              </a>
              <h4 class="text-dark font-weight-normal mt-4">
                <span class="font-weight-bold">SiPeDuLi Jembrana</span>
              </h4>
            </div>

            <div class="card card-primary">
              <div class="card-header">
                <h4>Verifikasi Email</h4>
              </div>

              <div class="card-body">
                <p>Kode verifikasi dikirimkan ke email <b>{{ (user) ? user.email : '' }}</b>.</p>
                <p>Silahkan login ke email Anda untuk lakukan verifikasi. Tidak mendapat email dari kami?</p>
                <button
                  type="button"
                  class="btn btn-primary btn-lg btn-block"
                  @click="sendLink"
                >
                  Kirim Ulang Email Verifikasi
                </button>
                <button
                  type="button"
                  class="btn btn-link btn-lg btn-block text-danger"
                  v-b-modal.modal-ubah-email
                >
                  Saya salah memasukkan email
                </button>
              </div>
            </div>
            <div class="simple-footer">
              Copyright &copy; 2021 Dinas Komunikasi Dan Informatika Kabupaten Jembrana
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal
      hide-footer
      id="modal-ubah-email"
      title="Ubah email"
    >
      <form
        action=""
        @submit="editEmail"
      >
        <div class="form-group">
          <label for="">Email</label>
          <input
            type="email"
            class="form-control"
            required
            v-model="form.email"
          >
        </div>
        <button
          id="btnSubmitEditAkun"
          class="btn btn-block btn-primary"
          type="submit"
        >
          Simpan
        </button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data () {
    return {
      form: {
        email: '',
        no_hp: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    sendLink () {
      let data = new FormData()
      data.append('data', '1')
      this.$store.dispatch('sendLinkEmailVerification', data).then(res => {
        if(res.data.status){
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Ada kesalahan",
            text: "Harap coba lagi nanti",
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        swal({
          title: "Ada kesalahan",
          text: "Harap coba lagi nanti",
          icon: "error",
          buttons: "Ok"
        })
      })
    },
    editEmail (e) {
      e.preventDefault()

      let button = document.querySelector('#btnSubmitEditAkun')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

      let formData = new FormData()

			formData.append('email', this.form.email)
			formData.append('no_hp', this.form.no_hp)

      this.$store.dispatch('updateProfile', formData).then(res => {
        if(res.data.status){
          swal({
            title: "Berhasil",
            text: "Berhasil mengubah email. Klik kirim ulang email verifikasi untuk melanjutkan.",
            icon: "success",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        this.$bvModal.hide('modal-ubah-email')

        this.$store.dispatch('fetchUser').then(resp => {
          let user = this.$store.getters.getUser
          this.form.email = user.email
          this.form.no_hp = user.no_hp
        })
      }).catch(err => {
        this.$bvModal.hide('modal-ubah-email')
        switch(err.response.status){
          case 500:
            this.$router.push({path: '/500'})
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
          
          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    }
  },
  beforeCreate(){
    this.$store.dispatch('fetchUser').then(res => {
      let user = this.$store.getters.getUser
      this.form.email = user.email
      this.form.no_hp = user.no_hp
      if(user.email_verified_at){
        this.$router.push({path: '/login'})
      }
    })
    .catch(err => {
      this.$router.push({path: '/'})
    })
  }
}
</script>